export default function () {
  return {
    currentUser: {},
    allUsers: [],
    workload: [],
    filterWeeks: null,
  }
}
